module.exports = __webpack_public_path__ + "img/greyDelete.ee2a6716.svg";